import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

// Evita repetir la llamada en la misma sesión; el servidor además cuenta
// una vez por usuario y por día.
const sentEvents = new Set();

export const recordAdEvent = (adId, type) => {
  const key = `${adId}:${type}`;
  if (!adId || sentEvents.has(key)) return;
  sentEvents.add(key);
  // Una métrica que no se registra nunca debe afectar a quien está mirando el anuncio.
  httpsCallable(functions, "recordAdEvent")({ adId, type }).catch(() => {
    sentEvents.delete(key);
  });
};
